import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import styled from 'styled-components'
import Header from '../components/Header'
import Favicon from './favicon.ico'
import * as colors from '../theme/colors'
import FaktumBold from './_fonts/Faktum-Bold.otf'
import FaktumExtraBold from './_fonts/Faktum-ExtraBold.otf'
import FaktumMedium from './_fonts/Faktum-Medium.otf'
import FaktumSemiBold from './_fonts/Faktum-SemiBold.otf'
import FaktumRegular from './_fonts/Faktum-Regular.otf'
import KeePulseImg from './_images/keep-pulse.png'
import './index.css'

const SiteContainer = styled.div`
  
  display: flex;
	flex-direction: column;
  color: #fff;
  @font-face {
    font-family: faktumBold;
    src: url(${FaktumBold});
  }
  @font-face {
    font-family: faktumExtraBold;
    src: url(${FaktumExtraBold});
  }
  @font-face {
    font-family: faktumMedium;
    src: url(${FaktumMedium});
  }
  @font-face {
    font-family: faktumSemiBold;
    src: url(${FaktumSemiBold});
  }
  @font-face {
    font-family: faktumRegular;
    src: url(${FaktumRegular});
  }
  
  font-family: faktumRegular;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  font-size: 24px;
  line-height: 1.2;

  a {
    text-decoration: none;
    color: #fff;
    
    &:hover {
      filter: brightness(90%);
      @media (max-width: 767px) {
        filter: none;
      }
    }
  }

  small {
    font-size: 14px;
    line-height: 16px;
  }

  h1 {
    font-family: avertaSemibold;
    font-size: 48px;
    line-height: 55px;
    margin-bottom: 30px;

    
  }

  h2 {
    font-family: faktumMedium;;
    font-size: 60px;
    line-height: 1.2;

    @media (max-width: 767px) {
      font-size: 32px;
      line-height: 40px;
      margin-bottom: 30px;
    }
  }

  h3 {
    font-family: avertaSemibold;
    font-size: 24px;
    line-height: 36px;
    margin-bottom: 18px;
  }

  h4 {
    font-family: avertaSemibold;
    color: ${colors.green};
    text-transform: uppercase;
    margin-bottom: 22px;
    font-size: 20px;
    line-height: 28px;
  }

  strong {
    font-family: avertaSemibold;
  }
`

const Content = styled.div`
  flex: 1 0 auto;
`

class TemplateWrapper extends Component {
  render() {
    return (
      <SiteContainer>
        <Helmet
          title="Squadlytics | Goal tracking for teams"
          meta={[
            {
              name: 'description',
              content: `Squadlytics helps team share goals and results to make sure that they're on track`
            }
          ]}
        >
          <link rel="canonical" href="https://squadlytics.com" />
          <meta property="og:site_name" content="Squadlytics" />
          <meta property="og:type" content="website" />
          <meta property="og:title" content="Squadlytics | Goal tracking for teams" />
          <meta property="og:description" content="Ditch emails and spreadsheets. Squadlytics is an easy and fun solution to track updates on projects and goals." />
          <meta property="og:url" content="https://squadlytics.com" />
          <meta property="og:image" content={`https://squadlytics.com${KeePulseImg}?20181105`} />
          
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Squadlytics | Goal tracking for teams" />
          <meta name="twitter:description" content="Ditch emails and spreadsheets. Squadlytics is an easy and fun solution to track updates on projects and goals." />
          <meta name="twitter:url" content="https://squadlytics.com" />
          <meta name="twitter:image" content={`https://squadlytics.com${KeePulseImg}?201811051`} />
          <meta name="twitter:site" content="@squadlytics" />
          <meta property="og:image:width" content="600" />
          <meta property="og:image:height" content="350" />
          <link rel="shortcut icon" type="image/x-icon" href={Favicon} />
          <script type="text/javascript">{`
            
          `}</script>
          <script>{`
            window.intercomSettings = {
              app_id: "c1x99y96"
            };
          `}</script>
          <script type="text/javascript">{`
            (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',intercomSettings);}else{var d=document;var i=function(){i.c(arguments)};i.q=[];i.c=function(args){i.q.push(args)};w.Intercom=i;function l(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/c1x99y96';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);}if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})()
          `}</script>
          <script>{`
            (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
            (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
            m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
            })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

            ga('create', 'UA-108365742-2', 'auto');
            ga('send', 'pageview');

          `}</script>
          <script async src="https://www.googletagmanager.com/gtag/js?id=AW-835101457"></script>
          <script>{`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'AW-835101457');
            `}
          </script>
          
          <script type="text/javascript">{`
            var _pfy = _pfy || [];(function(){function pfy_load(){var pfys=document.createElement('script');pfys.type='text/javascript';pfys.async=true;pfys.src='https://widget.prefinery.com/widget/v2/f8zo5v7b.js';var pfy=document.getElementsByTagName('script')[0];pfy.parentNode.insertBefore(pfys,pfy);}if (window.attachEvent){window.attachEvent('onload',pfy_load);}else{window.addEventListener('load',pfy_load,false);}})();`}
          </script>
          <script>{`
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '546988772409465');
            fbq('track', 'PageView');
            `}
          </script>
          <noscript>{`<img height="1" width="1" style="display:none"
            src="https://www.facebook.com/tr?id=546988772409465&ev=PageView&noscript=1"
          />`}</noscript>
        </Helmet>
        <Header />
        <Content>
          {this.props.children()}
        </Content>
      </SiteContainer>
    )
  }
}

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js